
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

interface UserSearchRequestParameters {
  logicalExpression?: string;
  filters: Array<{
    propertyName: string;
    type: string;
    value?: boolean;
    values?: Array<string>;
  }>;
  responseAttributes: Array<string>;
}

class User {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getUserFromCWS(parameters: UserSearchRequestParameters): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/users/search`, parameters, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }

  updateUser(catrecid: string, roleId: string): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<any>(`${this.baseUrl}/users/${catrecid}`, {
      "applications": [
        {
          "applicationId": "IOT",
          "entitlements": [
            {
              "partyNumber": "CAT",
              "accessType": "ACCESS_LEVEL",
              "accessIdentifiers": roleId ? [roleId] : []
            }
          ]
        }
      ]
  }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }
}

export default User;
